import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { networkRequest } from '@tencent/ark-request';
import { isAudioLike, isVideoLike } from '@tencent/docs-mime-types';
import { getXsrfToken } from "../cgi/cookies";
import { Backend } from "../types/backend";

/**
 * 请求 /api/drive/mediainfo 接口
 */
export function fetchMediaInfo(_x) {
  return _fetchMediaInfo.apply(this, arguments);
}

/**
 * drive/mediainfo 接口响应转成 DriveFile.previewInfo[videoMediaMetadata|audioMediaMetadata].canTranscode
 */
function _fetchMediaInfo() {
  _fetchMediaInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var rsp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return networkRequest.request({
            url: "/api/drive/mediainfo?xsrf=".concat(getXsrfToken()),
            method: 'POST',
            data: {
              file_id: params.fileId,
              obj_key: params.objKey
            }
          });
        case 2:
          rsp = _context.sent;
          return _context.abrupt("return", rsp);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchMediaInfo.apply(this, arguments);
}
export function transformMediaInfoToCanTranscode(raw) {
  var _keyMap;
  var keyMap = (_keyMap = {}, _defineProperty(_keyMap, Backend.TranscodeType.MP3Original, 'origin'), _defineProperty(_keyMap, Backend.TranscodeType.MP4Original, 'origin'), _defineProperty(_keyMap, Backend.TranscodeType.MP4FLU, 'v480p'), _defineProperty(_keyMap, Backend.TranscodeType.MP4HD, 'v720p'), _defineProperty(_keyMap, Backend.TranscodeType.MP4FHD, 'v1080p'), _keyMap);
  var canTranscode = {};
  raw.can_transcode_type.forEach(function (type) {
    var key = keyMap[type];
    if (key) canTranscode[key] = true;
  });
  return canTranscode;
}
export function addMediaInfoToPreviewInfo(_ref) {
  var previewInfo = _ref.previewInfo,
    mediaInfo = _ref.mediaInfo,
    _ref$mimeType = _ref.mimeType,
    mimeType = _ref$mimeType === void 0 ? '' : _ref$mimeType;
  var canTranscode = transformMediaInfoToCanTranscode(mediaInfo);
  var mediaMetaKey = null;
  if (isAudioLike(mimeType || '')) {
    mediaMetaKey = 'audioMediaMetadata';
  }
  if (isVideoLike(mimeType || '')) {
    mediaMetaKey = 'videoMediaMetadata';
  }
  if (mediaMetaKey && previewInfo) {
    return _objectSpread(_objectSpread({}, previewInfo), {}, _defineProperty({}, mediaMetaKey, Object.assign({}, previewInfo[mediaMetaKey], {
      canTranscode: canTranscode
    })));
  }
  return previewInfo;
}
//# sourceMappingURL=media-info.js.map